module.exports = __webpack_public_path__ + "static/media/close-mobile-menu.518c7a50.svg";